const analytics = {
  name: 'analytics',

  path: 'analytics',

  async getComponent() {
    const {AnalyticsMain} = await import('./AnalyticsRoutes');

    return AnalyticsMain;
  },

  async getChildRoutes() {
    const { AnalyticsRoutes } = await import('./AnalyticsRoutes');

    return AnalyticsRoutes;
  }
};

export default analytics;



// WEBPACK FOOTER //
// ./src/apps/Analytics/index.js